<template>
    <Modal>
        <template #title><span class="color-red">Delete the user</span></template>

        <p>
            The user can be linked to the trims created/exported by them.
            <br>
            Are you sure you definitely want to delete this user?
            <br>
            <br>
        </p>

        <p v-if="errorSend" class="color-red">{{ errorSend }}</p>

        <UserInfo v-if="user"
                  :user="user"
        ></UserInfo>

        <div v-if="disable" class="admin-info color-red">*The admin cannot delete their own account</div>

        <template #footer>
            <Button class="gray" @click="closeModal">Cancel</Button>

            <Button class="red"
                    :class="{disable}"
                    :loading="sendStatus"
                    @click="confirmDelete"
            >Delete</Button>
        </template>
    </Modal>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import Modal from "../../../components/Modal";
    import Button from "../../../components/Button";
    import UserInfo from "./UserInfo";

    export default {
        name: "DeleteUserModal",

        components: {
            UserInfo,
            Button,
            Modal,
        },

        emits: [
            'deleted',
        ],

        props: [
            'user', // a user to delete
        ],

        data() {
            return {
                sendStatus: false,
                errorSend: null,
            }
        },

        computed: {
            ...mapState('authentication', [
                'userId', // the current user (editor)
            ]),

            dateFormat() {
                return this.user.date_created?.slice(0,10);
            },

            userStatus() {
                return this.user.active ? 'active' : 'banned';
            },

            disable() {
                // if the edited user is also the current editor(user)
                return +this.userId === +this.user.id;
            },
        },

        methods: {
            ...mapActions('users', [
                'deleteUser',
            ]),

            closeModal() {
                this.$emit('closeModal');
            },

            confirmDelete() {
                this.sendStatus = true;

                this.deleteUser(this.user.id).then(
                    () => {
                        this.$emit('deleted');

                        this.closeModal();
                    }, (error) => {
                        this.errorSend = error;
                    })
                    .finally(() => {
                        this.sendStatus = false;
                    });
            },

        }

    }
</script>

<style scoped>
    dl {
        display: flex;
    }

    dt {
        width: 80px;
        font-weight: 700;
    }

    .disable,
    .disable:hover {
        color: #ccc;
        background: #888;
        cursor: not-allowed;
    }

    .admin-info {
        margin: 0 0 4px;
        font-size: 12px;
        /*color: #999;*/
    }

</style>